@if (!profissionalRecemCriado()) {
<form [formGroup]="form" (ngSubmit)="salvar()" class="n-form">
  <!-- Informações do Profissional -->
  <lib-n-fieldset icon="pi pi-user" [title]="'BARDO_PROFISSIONAIS.INFORMACOES_DE' | translate: { termo: $nicho().profissional.singular }">
    <div class="grid">
      <!-- Nome -->
      <div class="lg:col-12">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.NOME' | translate"
          controlName="nome"
          [required]="true"
          [maxLength]="50"
        >
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.NOME_PLACEHOLDER' | translate: { termo: ($nicho().profissional.singular | lowercase) }"
            maxlength="50"
            class="w-full"
          />
        </lib-form-field>
      </div>
      <!-- Descrição -->
      <div class="lg:col-12">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.DESCRICAO' | translate: { termo: ($nicho().profissional.singular | lowercase) }"
          controlName="descricao"
          [maxLength]="100"
        >
          <input
            pInputText
            id="descricao"
            formControlName="descricao"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.DESCRICAO_PLACEHOLDER' | translate"
            maxlength="100"
            class="w-full"
          />
        </lib-form-field>
      </div>

      <!-- Perfil de Acesso -->
      <div class="lg:col-6">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.PERFIL_ACESSO' | translate"
          controlName="perfilAcesso"
          [required]="true"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="perfilAcesso"
            [options]="$perfisDisponiveis()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.SELECIONE_PERFIL' | translate"
          />
          } @else {
          <p-select
            id="perfilAcesso"
            formControlName="perfilAcesso"
            [options]="$perfisDisponiveis()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.SELECIONE_PERFIL' | translate"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            styleClass="w-full"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
        @if ($avisoQuota()) {
          <small class="text-secondary block mt-1">{{ $avisoQuota() }}</small>
        }
      </div>

      <!-- Presta Atendimento -->
      <div class="lg:col-6">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.PRESTA_ATENDIMENTO' | translate"
          controlName="prestaAtendimento"
          [helpText]="'BARDO_PROFISSIONAIS.FORM.PRESTA_ATENDIMENTO_HELP' | translate: { clientes: ($nicho().cliente.plural | lowercase), perfil: ('BARDO_PROFISSIONAIS.PERFIS.PROFISSIONAL' | translate) }"
        >
          <p-togglebutton
            formControlName="prestaAtendimento"
            [onLabel]="'GLOBAL.SIM' | translate"
            [offLabel]="'GLOBAL.NAO' | translate"
            [offIcon]="'pi pi-times'"
            [onIcon]="'pi pi-check'"
            styleClass="w-full"
          />
        </lib-form-field>
      </div>

      <div class="lg:col-6">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.SERVICOS_DO_PROFISSIONAL' | translate: { servicos: $nicho().servico.plural, profissional: $nicho().profissional.singular }"
          controlName="servicosSelecionados"
          [required]="$servicosObrigatorios()"
          [helpText]="$servicosHelpText()"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            formControlName="servicosSelecionados"
            [options]="servicoDataService.$servicos()"
            optionLabel="nome"
            optionValue="id"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.SELECIONE_SERVICOS' | translate: { termo: ($nicho().servico.plural | lowercase) }"
            [maxSelectedLabels]="2"
            [selectedItemsLabel]="'BARDO_PROFISSIONAIS.FORM.ITENS_SELECIONADOS' | translate"
            [showHeader]="true"
          />
          } @else {
          <p-multiSelect
            id="servicosSelecionados"
            formControlName="servicosSelecionados"
            [options]="servicoDataService.$servicos()"
            optionLabel="nome"
            optionValue="id"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.SELECIONE_SERVICOS' | translate: { termo: ($nicho().servico.plural | lowercase) }"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            [maxSelectedLabels]="2"
            [selectedItemsLabel]="'BARDO_PROFISSIONAIS.FORM.ITENS_SELECIONADOS' | translate"
            [style]="{ width: '100%' }"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>

      <div class="lg:col-6">
        <lib-form-field [label]="'BARDO_PROFISSIONAIS.FORM.ESTA_DE_FERIAS' | translate" controlName="ferias">
          <p-togglebutton
            formControlName="ferias"
            [onLabel]="'GLOBAL.SIM' | translate"
            [offLabel]="'GLOBAL.NAO' | translate"
            [offIcon]="'pi pi-times'"
            [onIcon]="'pi pi-check'"
            styleClass="w-full"
          />
        </lib-form-field>
      </div>
    </div>
  </lib-n-fieldset>

  <!-- Horários de Trabalho -->
  <lib-n-fieldset icon="pi pi-clock" [title]="'BARDO_PROFISSIONAIS.FORM.HORARIOS_TRABALHO' | translate">
    @if ($expedienteHelpText()) {
      <small class="block mb-3 text-600">{{ $expedienteHelpText() }}</small>
    }
    <div class="grid">
      <!-- Dias de Trabalho -->
      <div class="lg:col-12 md:col-12 sm:col-12">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.DIAS_TRABALHO' | translate"
          controlName="diasSelecionados"
          [required]="$expedienteObrigatorio()"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            formControlName="diasSelecionados"
            [options]="$diasDisponiveis()"
            optionLabel="label"
            optionValue="id"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.SELECIONE_DIAS' | translate"
            [showHeader]="false"
          />
          } @else {
          <p-multiSelect
            [options]="$diasDisponiveis()"
            formControlName="diasSelecionados"
            optionLabel="label"
            optionValue="id"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.SELECIONE_DIAS' | translate"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            [showHeader]="false"
            display="chip"
            styleClass="w-full"
            [appendTo]="$dropdownAppendTo()"
          ></p-multiSelect>
          } @if ($diasDisponiveis().length === 0) {
          <small class="text-danger mt-2 block">
            {{ 'BARDO_PROFISSIONAIS.FORM.CONFIGURAR_DIAS_AVISO' | translate: { termo: ($nicho().profissional.plural | lowercase) } }}
          </small>
          }
        </lib-form-field>
      </div>

      <!-- Início do Expediente -->
      <div class="lg:col-6 md:col-6 sm:col-12">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.INICIO_EXPEDIENTE' | translate"
          controlName="inicioExpediente"
          [required]="$expedienteObrigatorio()"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="inicioExpediente"
            [options]="horariosInicio"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
          />
          } @else {
          <p-select
            [options]="horariosInicio"
            formControlName="inicioExpediente"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            styleClass="w-full"
            scrollHeight="80px"
            [appendTo]="$dropdownAppendTo()"
          ></p-select>
          }
        </lib-form-field>
      </div>

      <!-- Fim do Expediente -->
      <div class="lg:col-6 md:col-6 sm:col-12">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.FORM.FIM_EXPEDIENTE' | translate"
          controlName="fimExpediente"
          [required]="$expedienteObrigatorio()"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="fimExpediente"
            [options]="horariosFim"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
          />
          } @else {
          <p-select
            [options]="horariosFim"
            formControlName="fimExpediente"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            styleClass="w-full"
            scrollHeight="80px"
            [appendTo]="$dropdownAppendTo()"
          ></p-select>
          }
        </lib-form-field>
      </div>
    </div>
  </lib-n-fieldset>

  <!-- Intervalo de Almoço -->
  <lib-n-fieldset icon="pi pi-clock" [title]="'BARDO_PROFISSIONAIS.FORM.INTERVALO_ALMOCO' | translate">
    <div class="grid">
      <!-- Início do Almoço -->
      <div class="lg:col-6 md:col-6 sm:col-12">
        <lib-form-field [label]="'BARDO_PROFISSIONAIS.FORM.INICIO_ALMOCO' | translate" controlName="almocoInicio">
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="almocoInicio"
            [options]="horariosAlmocoInicio"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
          />
          } @else {
          <p-select
            class="w-full"
            [options]="horariosAlmocoInicio"
            formControlName="almocoInicio"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            styleClass="w-full"
            scrollHeight="80px"
            [showClear]="true"
            [appendTo]="$dropdownAppendTo()"
          ></p-select>
          }
        </lib-form-field>
      </div>

      <!-- Fim do Almoço -->
      <div class="lg:col-6 md:col-6 sm:col-12">
        <lib-form-field [label]="'BARDO_PROFISSIONAIS.FORM.FIM_ALMOCO' | translate" controlName="almocoFim">
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="almocoFim"
            [options]="horariosAlmocoFim"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
          />
          } @else {
          <p-select
            class="w-full"
            [options]="horariosAlmocoFim"
            formControlName="almocoFim"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_PROFISSIONAIS.FORM.HORARIO_PLACEHOLDER' | translate"
            [emptyMessage]="'BARDO_PROFISSIONAIS.FORM.NENHUM_RESULTADO' | translate"
            styleClass="w-full"
            scrollHeight="80px"
            [showClear]="true"
            [appendTo]="$dropdownAppendTo()"
          ></p-select>
          }
        </lib-form-field>
      </div>
    </div>
  </lib-n-fieldset>
</form>
}

@if (profissionalRecemCriado()) {
  <p-message
    severity="success"
    [text]="'BARDO_PROFISSIONAIS.FORM.CADASTRADO_COM_SUCESSO' | translate: { termo: $nicho().profissional.singular }"
    styleClass="mb-3 w-full"
  />
}

<!-- Acesso ao Sistema — visível ao editar profissional existente ou logo após criar um novo -->
@if (profissional?.id) {
  <lib-n-fieldset icon="pi pi-lock" [title]="'BARDO_PROFISSIONAIS.FORM.ACESSO_SISTEMA' | translate">
    @if (temAcessoAtivo) {
      <div class="flex align-items-center gap-2">
        <i class="pi pi-check-circle text-green-500"></i>
        <span class="text-green-700 font-medium">{{ 'BARDO_PROFISSIONAIS.FORM.ACESSO_ATIVO' | translate }}</span>
      </div>
      @if (emailMascarado || telefoneMascarado) {
        <div class="n-acesso-info">
          @if (emailMascarado) {
            <div class="n-acesso-info-item">
              <i class="pi pi-envelope"></i>
              <span>{{ emailMascarado }}</span>
            </div>
          }
          @if (telefoneMascarado) {
            <div class="n-acesso-info-item">
              <i class="pi pi-phone"></i>
              <span>{{ telefoneMascarado }}</span>
            </div>
          }
        </div>
      }
      <small class="block mt-2 text-600">
        {{ 'BARDO_PROFISSIONAIS.FORM.REMOVER_ACESSO_DICA' | translate: { termo: ($nicho().profissional.plural | lowercase) } }}
      </small>

    } @else {
      <p-togglebutton
        [(ngModel)]="habilitarAcessoAtivoValue"
        [onLabel]="'BARDO_PROFISSIONAIS.FORM.HABILITAR_ACESSO' | translate"
        [offLabel]="'BARDO_PROFISSIONAIS.FORM.SEM_ACESSO' | translate"
        onIcon="pi pi-unlock"
        offIcon="pi pi-lock"
      />

      @if (habilitarAcessoAtivo()) {
        <form [formGroup]="formAcesso" class="mt-3">
          <p-message
            severity="info"
            [text]="'BARDO_PROFISSIONAIS.FORM.CONTA_EXISTENTE_AVISO' | translate"
            styleClass="mb-3 w-full"
          />
          <div class="grid">
            <div class="lg:col-6">
              <lib-form-field [label]="'GLOBAL.EMAIL' | translate" controlName="email" [required]="true">
                <input pInputText formControlName="email" type="email" class="w-full" placeholder="email@exemplo.com" />
              </lib-form-field>
            </div>
            <div class="lg:col-6">
              <lib-form-field [label]="'GLOBAL.TELEFONE' | translate" controlName="telefone" [required]="true">
                <lib-phone-input
                  [value]="formAcesso.get('telefone')?.value ?? ''"
                  (valueChange)="onTelefoneAcessoChange($event)"
                />
              </lib-form-field>
            </div>
            <div class="lg:col-12">
              <lib-form-field [label]="'BARDO_PROFISSIONAIS.FORM.SENHA_INICIAL' | translate" controlName="senha" [required]="true">
                <p-password formControlName="senha" [toggleMask]="true" [feedback]="false" styleClass="w-full" />
              </lib-form-field>
            </div>
          </div>
          <p-button
            [label]="'BARDO_PROFISSIONAIS.FORM.SALVAR_ACESSO' | translate"
            icon="pi pi-save"
            [loading]="salvandoAcesso()"
            [disabled]="formAcesso.invalid || salvandoAcesso()"
            (onClick)="salvarAcesso()"
          />
        </form>
      }
    }
  </lib-n-fieldset>
}

<ng-template #footerTemplate>
  @if (profissionalRecemCriado()) {
    <p-button
      class="w-full"
      [label]="'GLOBAL.FECHAR' | translate"
      icon="pi pi-times"
      (onClick)="concluirCriacao()"
      styleClass="w-full"
    />
  } @else {
    <p-button
      class="w-full"
      [label]="profissional ? ('GLOBAL.SALVAR' | translate) : ('GLOBAL.PROXIMO' | translate)"
      [icon]="profissional ? 'pi pi-check' : 'pi pi-arrow-right'"
      (onClick)="salvar()"
      [loading]="salvando()"
      [disabled]="form.invalid || salvando()"
      styleClass="w-full"
    />
  }
</ng-template>
